import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IPixabayImages } from '@boxx/boxx-images/lib/contracts/IImages';
import {
  AbstractAppConfigService,
  APP_CONFIG_SERVICE,
  IHttpBasicResponse,
  IHttpBasicResponseEcwid,
  IHttpBasicResponseImageEcwid,
  IHttpBasicResponseStore
} from '@boxx/core';
import { IProductImageUpload } from '@boxx/store-core';
import { Observable } from 'rxjs';
import { EcwidModel } from '../models/Ecwid.model';
import { StoreProfileModel } from '../models/Store.model';
import {
  ICategoryApiModel,
  ICategoryImageUploadApiModel,
  ICreateOrderPayload,
  ICreateVariationPayload,
  IImageApiModel,
  IOrderApiModel,
  IProductApiModel,
  IProfileApiModel,
  IUpdateStatusOrderPayload,
  IVariationApiModel,
} from '../repositories/IStore.api';
import { IStoreRepository } from '../repositories/IStore.repository';

@Injectable()
export class StoreRepositoryMock implements IStoreRepository {

  constructor(
    @Inject(APP_CONFIG_SERVICE) private appSettings: AbstractAppConfigService,
    private httpClient: HttpClient
  ) {}

  loadCategoryById(
  ): Observable<IHttpBasicResponse<ICategoryApiModel>> {
    throw new Error('Method not implemented.');
  }
  loadOrderById(id: string): Observable<IHttpBasicResponse<IOrderApiModel>> {
    throw new Error('Method not implemented.');
  }
  updateOrder(payload: IUpdateStatusOrderPayload): Observable<IHttpBasicResponse<any>> {
    return this.httpClient.post<IHttpBasicResponse<EcwidModel>>(
      `https://boxx-crm-staging.virket.net/api/json/v1/ecwid/update_order/${payload.id}`,
      payload
    );
  }
  createOrder(payload: ICreateOrderPayload): Observable<IHttpBasicResponse<any>> {
    throw new Error('Method not implemented.');
  }

  loadProductById(
  ): Observable<IHttpBasicResponse<IProductApiModel>> {
    throw new Error('Method not implemented.');
  }
  loadProductsVariations(
  ): Observable<IHttpBasicResponse<IVariationApiModel[]>> {
    throw new Error('Method not implemented.');
  }
  loadProductVariationByVariationId(
  ): Observable<IHttpBasicResponse<IVariationApiModel>> {
    throw new Error('Method not implemented.');
  }
  createProductVariation(
  ): Observable<IHttpBasicResponse<IVariationApiModel>> {
    throw new Error('Method not implemented.');
  }
  deleteProductVariation(id: number): Observable<IHttpBasicResponse<null>> {
    throw new Error('Method not implemented.');
  }
  loadSiteImages(
  ): Observable<IHttpBasicResponse<IImageApiModel[]>> {
    throw new Error('Method not implemented.');
  }
  loadSiteImageById(
  ): Observable<IHttpBasicResponse<IImageApiModel>> {
    throw new Error('Method not implemented.');
  }
  createSiteImage(
  ): Observable<IHttpBasicResponse<IImageApiModel>> {
    throw new Error('Method not implemented.');
  }
  deleteSiteImage(id: number): Observable<IHttpBasicResponse<null>> {
    throw new Error('Method not implemented.');
  }

  // --------------------- CATEGORIES: -------------------------
  loadCategories(
  ): Observable<IHttpBasicResponseEcwid<ICategoryApiModel[]>> {
    return this.httpClient.get<IHttpBasicResponseEcwid<ICategoryApiModel[]>>(
      `https://boxx-crm-staging.virket.net/api/json/v1/ecwid/categories`
    );
  }

  getSingleCategory(
    id: number
  ): Observable<IHttpBasicResponseImageEcwid<ICategoryImageUploadApiModel>> {
    return this.httpClient.get<IHttpBasicResponseImageEcwid<ICategoryImageUploadApiModel>>(
      `https://boxx-crm-staging.virket.net/api/json/v1/ecwid/category/${id}`
    );
  }

  createCategory(payload: any): Observable<IHttpBasicResponse<any>> {
    return this.httpClient.post<IHttpBasicResponse<EcwidModel>>(
      `https://boxx-crm-staging.virket.net/api/json/v1/ecwid/add_category`,
      payload
    );
  }

  searchImages(params: any): Observable<IHttpBasicResponse<IPixabayImages>> {
    var headers = new HttpHeaders()
     headers.append('Content-Type', 'application/x-www-form-urlencoded');
    const urlSearchParams = new URLSearchParams();
    Object.keys(params).forEach((key: string) => {
      urlSearchParams.append(key, params[key]);
    });

    const body = urlSearchParams.toString();
    return this.httpClient.post<IHttpBasicResponse<IPixabayImages>>(
      `${this.getBaseUrlPixaBay()}/api/json/v1/builder/getPixInfo`,  
      body, { headers } 
    );
  }
 

  // createCategory(payload: any): Promise<any> {

  //   return new Promise((resolve) => {
  //     const promises: Promise<any>[] = [];

  //         promises.push(
  //           new Promise((resolve, reject) => {
  //             this.httpClient.post<IHttpBasicResponse<EcwidModel>>(
  //               `https://boxx-crm-staging.virket.net/api/json/v1/ecwid/add_category`,
  //               payload
  //             ).subscribe(
  //               (cat) => {
  //                 if(payload.image){

  //                   const urlSearchParams = new URLSearchParams();
  //                   urlSearchParams.append('file', payload.image);
  //                   const body = urlSearchParams.toString();

  //                   new Promise((resolve, reject) => {
  //                     this.httpClient.post<IHttpBasicResponse<EcwidModel>>(
  //                       `https://boxx-crm-staging.virket.net/api/json/v1/ecwid/image_category/${cat.data.id}`,
  //                       body
  //                     ).subscribe(
  //                       (response) => {
  //                         resolve(response);
  //                       },
  //                       (error) => reject(error)
  //                     );
  //                   })
  //                 }
  //                 else{
  //                   resolve(cat);
  //                 }                  
  //               },
  //               (error) => reject(error)
  //             );
  //           })
  //         );
  //   });

  // }

  updateCategory(payload: any): Observable<IHttpBasicResponse<any>> {
    return this.httpClient.post<IHttpBasicResponse<EcwidModel>>(
      `https://boxx-crm-staging.virket.net/api/json/v1/ecwid/update_category/${payload.id}`,
      payload
    );
  }
  deleteCategory(payload: any): Observable<IHttpBasicResponse<any>> {
    return this.httpClient.delete<IHttpBasicResponse<EcwidModel>>(
      `https://boxx-crm-staging.virket.net/api/json/v1/ecwid/delete_category/${payload}`
    );
  }

  uploadImageCategory(id: number, fileBase: string): Observable<IHttpBasicResponse<any>> {
    const urlSearchParams = new URLSearchParams();
    urlSearchParams.append('file', fileBase);
    const body = urlSearchParams.toString();

    return this.httpClient.post<IHttpBasicResponse<EcwidModel>>(
      `https://boxx-crm-staging.virket.net/api/json/v1/ecwid/image_category/${id}`,
      body
    );
  }

  deleteImageCategory(payload: any): Observable<IHttpBasicResponse<any>> {
    return this.httpClient.delete<IHttpBasicResponse<EcwidModel>>(
      `https://boxx-crm-staging.virket.net/api/json/v1/ecwid/delete_image_category/${payload}`
    );
  }

  // --------------------- ORDERS: -------------------------
  loadOrders(): Observable<IHttpBasicResponseEcwid<IOrderApiModel[]>> {
    console.warn('--- StoreRepositoryMock::loadOrders()');
    return this.httpClient.get<IHttpBasicResponseEcwid<IOrderApiModel[]>>(
      `https://boxx-crm-staging.virket.net/api/json/v1/ecwid/orders`
    );
  }
  acceptOrder(payload: any): Observable<IHttpBasicResponse<any>> {
    throw new Error('Method not implemented.');
  }
  notifyOrderShipment(payload: any): Observable<IHttpBasicResponse<any>> {
    throw new Error('Method not implemented.');
  }
  notifyOrderDelivery(payload: any): Observable<IHttpBasicResponse<any>> {
    throw new Error('Method not implemented.');
  }
  deleteOrder(payload: any): Observable<IHttpBasicResponse<any>> {
    throw new Error('Method not implemented.');
  }

  // --------------------- PRODUCTS: -------------------------
  loadProducts(
  ): Observable<IHttpBasicResponseEcwid<IProductApiModel[]>> {
    return this.httpClient.get<IHttpBasicResponseEcwid<IProductApiModel[]>>(
      `https://boxx-crm-staging.virket.net/api/json/v1/ecwid/products`
    );
  }
  createProduct(payload: any): Observable<IHttpBasicResponse<any>> {
    return this.httpClient.post<IHttpBasicResponse<EcwidModel>>(
      `https://boxx-crm-staging.virket.net/api/json/v1/ecwid/add_product`,
      payload
    );
  }
  updateProduct(payload: any): Observable<IHttpBasicResponse<any>> {
    return this.httpClient.post<IHttpBasicResponse<EcwidModel>>(
      `https://boxx-crm-staging.virket.net/api/json/v1/ecwid/update_product/${payload.id}`,
      payload
    );
  }
  deleteProduct(payload: any): Observable<IHttpBasicResponse<any>> {
    return this.httpClient.delete<IHttpBasicResponse<EcwidModel>>(
      `https://boxx-crm-staging.virket.net/api/json/v1/ecwid/delete_product/${payload}`
    );
  }

  getSingleProduct(
    id: number
  ): Observable<IHttpBasicResponseImageEcwid<IProductApiModel>> {
    return this.httpClient.get<IHttpBasicResponseImageEcwid<IProductApiModel>>(
      `https://boxx-crm-staging.virket.net/api/json/v1/ecwid/single_product/${id}`
    );
  }

  uploadImageProduct(payload: IProductImageUpload): Observable<IHttpBasicResponse<any>> {
    const urlSearchParams = new URLSearchParams();
    urlSearchParams.append('file', payload.file);
    if(payload.gallery){      
      urlSearchParams.append('gallery', payload.gallery.toString());
    }
    const body = urlSearchParams.toString();

    return this.httpClient.post<IHttpBasicResponse<EcwidModel>>(
      `https://boxx-crm-staging.virket.net/api/json/v1/ecwid/add_image_product/${payload.id}`,
      body
    );
  }
  deleteImageProduct(payload: any): Observable<IHttpBasicResponse<null>> {
    if(payload.type == 1){
      return this.httpClient.delete<IHttpBasicResponse<null>>(
        `https://boxx-crm-staging.virket.net/api/json/v1/ecwid/delete_main_picture/${payload.id}`
      );
    }
    else {
      return this.httpClient.delete<IHttpBasicResponse<null>>(
        `https://boxx-crm-staging.virket.net/api/json/v1/ecwid/delete_picture/${payload.id}/${payload.index}`
      );
    }
  }


  // --------------------- ECWID: -------------------------
  getLinkValidation(): Observable<IHttpBasicResponse<EcwidModel>> {
    return this.httpClient.get<IHttpBasicResponse<EcwidModel>>(
      `https://boxx-crm-staging.virket.net/api/json/v1/ecwid/get_link`
    );
  }

  getLinkSSO(): Observable<IHttpBasicResponse<EcwidModel>> {
      return this.httpClient.get<IHttpBasicResponse<EcwidModel>>(
        `https://boxx-crm-staging.virket.net/api/json/v1/ecwid/sso`
      );
  }
   
  openSSOHidden(url: string): Observable<IHttpBasicResponse<EcwidModel>> {
      return this.httpClient.get<IHttpBasicResponse<EcwidModel>>(
        url
      );
  }
  

  getToken(
    bId: number, businessId: number
  ): Observable<IHttpBasicResponse<EcwidModel>> {
    const body = null;
    return this.httpClient.post<IHttpBasicResponse<EcwidModel>>(
      `https://boxx-crm-staging.virket.net/api/json/v1/Oauthwid/update/${bId}/${businessId}`,
      body
    );
  }

  getProfile(): Observable<IHttpBasicResponseStore<StoreProfileModel>> {
    const body = null;
    return this.httpClient.post<IHttpBasicResponseStore<StoreProfileModel>>(
      `https://boxx-crm-staging.virket.net/api/json/v1/ecwid/profile`,
      body
    );
  }

  updateProfile(payload: any): Observable<IHttpBasicResponse<any>> {
    return this.httpClient.post<IHttpBasicResponse<IProfileApiModel>>(
      `https://boxx-crm-staging.virket.net/api/json/v1/ecwid/profile_update`,
      payload
    );
  }

  uploadImageProfile(fileBase: string): Observable<IHttpBasicResponse<any>> {
    const urlSearchParams = new URLSearchParams();
    urlSearchParams.append('file', fileBase);
    const body = urlSearchParams.toString();

    return this.httpClient.post<IHttpBasicResponse<EcwidModel>>(
      `https://boxx-crm-staging.virket.net/api/json/v1/ecwid/add_profile_logo`,
      body
    );
  }

  deleteImageProfile(payload: any): Observable<IHttpBasicResponse<any>> {
    return this.httpClient.delete<IHttpBasicResponse<EcwidModel>>(
      `https://boxx-crm-staging.virket.net/api/json/v1/ecwid/delete_logo`
    );
  }

  private getBaseUrlPixaBay() {
    return `${this.appSettings.baseUrl()}/`;
  }



  // --------------------- COUPONS: -------------------------
  loadCoupons(
    ): Observable<IHttpBasicResponseEcwid<any[]>> {
      return this.httpClient.get<IHttpBasicResponseEcwid<any[]>>(
        `https://boxx-crm-staging.virket.net/api/json/v1/ecwid/coupons`
      );
    }
    createCoupon(payload: any): Observable<IHttpBasicResponse<any>> {
      return this.httpClient.post<IHttpBasicResponse<EcwidModel>>(
        `https://boxx-crm-staging.virket.net/api/json/v1/ecwid/add_coupon`,
        payload
      );
    }
    updateCoupon(payload: any): Observable<IHttpBasicResponse<any>> {
      return this.httpClient.post<IHttpBasicResponse<EcwidModel>>(
        `https://boxx-crm-staging.virket.net/api/json/v1/ecwid/update_coupon/${payload.id}`,
        payload
      );
    }
    deleteCoupon(payload: any): Observable<IHttpBasicResponse<any>> {
      return this.httpClient.delete<IHttpBasicResponse<EcwidModel>>(
        `https://boxx-crm-staging.virket.net/api/json/v1/ecwid/delete_coupon/${payload}`
      );
    }
    getSingleCoupon(
      id: number
    ): Observable<IHttpBasicResponseImageEcwid<any>> {
      return this.httpClient.get<IHttpBasicResponseImageEcwid<any>>(
        `https://boxx-crm-staging.virket.net/api/json/v1/ecwid/single_coupon/${id}`
      );
    }

}
